import React, { useState } from "react";

import Button from "@mui/material/Button";
import FormGroup from "@mui/material/FormGroup";
import Grid from "@mui/material/Grid";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import makeStyles from '@mui/styles/makeStyles';

import { Article, FormFooter } from "./Layout";
import { dataFilteringQueryUrl, permalinkUrl } from "./Url";

const dataFilteringStyles = makeStyles(theme => ({
  filteringFields: {
    padding: theme.spacing(2)
  }
}));

const DataFiltering = props => {
  /* set state */
  const [isDisabled, setIsDisabled] = useState(true);
  const [isWeekly, setIsWeekly] = useState(false);

  /* extract props */
  const {
    endDate,
    modelIds,
    startDate,
    resolution,
    smoothing,
    errorCallback,
    onChangeCallback,
    permalinkCallback,
    updateCallback
  } = props;

  const queryUrl = dataFilteringQueryUrl(
    modelIds,
    startDate,
    endDate,
    resolution,
    smoothing
  );

  const handlePropsChange = event => {
    onChangeCallback(event);
    setIsDisabled(false);
  };

  const handleResolutionChange = event => {
    onChangeCallback(event);
    setIsWeekly(event.target.value === "week");
    setIsDisabled(false);
  };

  const handleSubmit = (queryUrl, isWeekly) => event => {
    event.preventDefault();
    fetch(queryUrl)
      .then(response => {
        if (!response.ok) {
          throw Error("DataFiltering: Cannot fetch scores from API");
        }
        return response.json();
      })
      .then(jsondata => {
        updateCallback(jsondata);
      })
      .catch(error => {
        errorCallback(error.message);
      });
    const plink = permalinkUrl(
      modelIds,
      startDate,
      endDate,
      resolution,
      smoothing
    );
    permalinkCallback(plink);
    setIsDisabled(true);
  };

  const classes = dataFilteringStyles(props.theme);

  return (
    <Article header="Data Filtering">
      <Grid item xs={12}>
        <form onSubmit={handleSubmit(queryUrl, isWeekly)}>
          <Grid container spacing={2} className={classes.filteringFields}>
            <Grid item xs={3}>
              <FormGroup>
                <InputLabel htmlFor="start-date">Start</InputLabel>
                <Input
                  type="date"
                  name="startDate"
                  id="start-date"
                  value={startDate}
                  onChange={handlePropsChange}
                />
                <Typography variant="caption">
                  Only show data collected on or after this date
                </Typography>
              </FormGroup>
            </Grid>
            <Grid item xs={3}>
              <FormGroup>
                <InputLabel htmlFor="end-date">End</InputLabel>
                <Input
                  type="date"
                  name="endDate"
                  id="end-date"
                  value={endDate}
                  onChange={handlePropsChange}
                />
                <Typography variant="caption">
                  Only show data collected on or before this date
                </Typography>
              </FormGroup>
            </Grid>
            <Grid item xs={3}>
              <FormGroup>
                <InputLabel htmlFor="resolution">Resolution</InputLabel>
                <Select
                  value={resolution}
                  onChange={handleResolutionChange}
                  inputProps={{ name: "resolution", id: "resolution" }}
                >
                  <MenuItem value="day">Day</MenuItem>
                  <MenuItem value="week">Week</MenuItem>
                </Select>
                <Typography variant="caption">
                  How many data points to show
                </Typography>
              </FormGroup>
            </Grid>
            <Grid item xs={3}>
              <FormGroup>
                <InputLabel htmlFor="smoothing">Smoothing</InputLabel>
                <Select
                  value={smoothing}
                  onChange={handlePropsChange}
                  inputProps={{ name: "smoothing", id: "smoothing" }}
                >
                  <MenuItem value={0}>No smoothing</MenuItem>
                  <MenuItem value={3}>3-day moving average</MenuItem>
                  <MenuItem value={5}>5-day moving average</MenuItem>
                  <MenuItem value={7}>7-day moving average</MenuItem>
                </Select>
                <Typography variant="caption">
                  Smooth the data to avoid overly spiky results
                </Typography>
              </FormGroup>
            </Grid>
          </Grid>
          <FormFooter>
            {isDisabled ? (
              <Button type="submit" variant="contained" disabled>
                Show data
              </Button>
            ) : (
              <Button type="submit" variant="contained">
                Show data
              </Button>
            )}
          </FormFooter>
        </form>
      </Grid>
    </Article>
  );
};

export default DataFiltering;
